import React from "react";
import GenericInput from "@ui-components/Input/GenericInput";
import GenericButton from "@ui-components/Button/GenericButton";

interface ClusterStep1Props {
  clusterName: string;
  setClusterName: (val: string) => void;
  description: string;
  setDescription: (val: string) => void;
  onNext?: () => void;
  onCancel: () => void;
}

const ClusterStep1: React.FC<ClusterStep1Props> = ({ clusterName, setClusterName, description, setDescription, onNext, onCancel }) => (
  <div className="flex flex-col gap-6 pt-4">
    <div>
      <h2 className="text-lg font-semibold mb-2">Create cluster</h2>
      <p className="text-sm text-semantic-text-secondary mb-4">
        Configure a high-availability cluster with two CTX Reflectors
      </p>
      <div className="flex flex-col gap-4">
        <GenericInput
          label="Cluster name"
          value={clusterName}
          onChange={setClusterName}
          required
        />
        <GenericInput
          label="Description"
          value={description}
          onChange={setDescription}
          required
        />
      </div>
    </div>
    <div className="flex justify-end gap-2">
      <GenericButton label="Cancel" variant="secondary" onClick={onCancel} />
      <GenericButton label="Next" variant="brand" onClick={onNext} disabled={!onNext} />
    </div>
  </div>
);

export default ClusterStep1; 